// extracted by mini-css-extract-plugin
export default {"user":"UserMenu_user__eFrAZ","user__li":"UserMenu_user__li__jqsaD","icon":"UserMenu_icon__JEX9w"};